export default __webpack_public_path__ + "static/partnerColorIcon4-89d56d9f556982a980a46b279435a3bc.svg";